"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotaoVoltar = void 0;
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importDefault(require("react"));
var icon_with_hyperlink_1 = require("../icon-with-hyperlink");
var botao_voltar_styles_1 = require("./botao-voltar.styles");
var BotaoVoltar = function (_a) {
    var onClick = _a.onClick, ariaLabel = _a.ariaLabel, id = _a.id, className = _a.className, bgColor = _a.bgColor;
    return (react_1.default.createElement(botao_voltar_styles_1.BotaoVoltarStyled, { "data-testid": "botao-voltar", className: className },
        react_1.default.createElement(icon_with_hyperlink_1.IconWithHyperlink, { id: id, icon: react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.ArrowLeft, bgColor: bgColor }), label: "Voltar", ariaLabel: ariaLabel, onClick: onClick, dataElement: "link_voltar", bgColor: bgColor })));
};
exports.BotaoVoltar = BotaoVoltar;
